import { type DuroRouteObject } from '~/shared/routing/types';
import { ChartPage } from './ChartPage';
import { PatientOverviewRoute } from './routes/PatientOverviewRoute';
import { WorkflowStageTaskListRoute } from './routes/WorkflowStageTaskListRoute';
import { ChartWorkflowStageTaskRoute } from './routes/ChartWorkflowStageTaskRoute';
import { PatientPhysiciansRoute } from './routes/profile/PatientPhysiciansRoute';
import { PatientOrdersRoute } from './routes/orders/PatientOrdersRoute';
import { PatientOrderRoute } from './routes/orders/PatientOrderRoute';
import { PlanOfCareRoute } from './routes/PlanOfCareRoute';
import { PatientAddressesRoute } from './routes/profile/PatientAddressesRoute';
import { PatientAdvanceDirectivesRoute } from './routes/profile/PatientAdvanceDirectivesRoute';
import { PatientContactsRoute } from './routes/profile/PatientContactsRoute';
import { PatientImmunizationsRoute } from './routes/profile/PatientImmunizationsRoute';
import { PatientDemographicsRoute } from './routes/profile/PatientDemographicsRoute';
import { PlanOfCareReviewRoute } from './routes/QaRoutes';
import { PlanOfCareReview } from '~/features/qa/poc-reviews/PlanOfCareReview';

export const chartRoutes: DuroRouteObject = {
	path: '/charts/:patientId/:stayId/:certificationPeriodId',
	element: <ChartPage />,
	children: [
		{
			index: true,
			element: <PatientOverviewRoute />
		},
		{
			path: 'tasks',
			element: <WorkflowStageTaskListRoute />,
			handle: { menuLabel: 'Tasks' }
		},
		{
			path: 'tasks/:taskId',
			element: <ChartWorkflowStageTaskRoute />,
			handle: { menuLabel: 'Task Details' }
		},
		{
			path: 'profile',
			children: [
				{
					path: 'demographics',
					element: <PatientDemographicsRoute />,
					handle: {
						menuLabel: 'Demographics'
					}
				},
				{
					path: 'addresses',
					element: <PatientAddressesRoute />,
					handle: {
						menuLabel: 'Addresses'
					}
				},
				{
					path: 'advanced-directives',
					element: <PatientAdvanceDirectivesRoute />,
					handle: {
						menuLabel: 'Advance Directives'
					}
				},
				{
					path: 'contacts',
					element: <PatientContactsRoute />,
					handle: {
						menuLabel: 'Contacts'
					}
				},
				{
					path: 'immunizations',
					element: <PatientImmunizationsRoute />,
					handle: {
						menuLabel: 'Immunizations'
					}
				}
			]
		},
		{
			path: 'orders',
			children: [
				{
					path: 'list',
					element: <PatientOrdersRoute />,
					handle: { menuLabel: 'Orders' }
				},
				{
					path: 'physicians',
					element: <PatientPhysiciansRoute />,
					handle: { menuLabel: 'Physicians' }
				},
				{
					path: 'order/:orderId',
					element: <PatientOrderRoute />,
					handle: { menuLabel: 'Order' }
				}
			]
		},
		{
			path: 'plan-of-care',
			index: true,
			element: <PlanOfCareRoute />
		},
		{
			path: 'qa',
			children: [
				{
					path: 'poc-reviews',
					element: <PlanOfCareReviewRoute />,
					handle: { menuLabel: 'Plan of Care Reviews' }
				},
				{
					path: 'poc-reviews/:reviewId',
					element: <PlanOfCareReview />,
					handle: { menuLabel: 'Plan of Care Review' }
				}
			]
		},
		// {
		// 	path: 'demographics',
		// 	element: <p>de</p>,
		// 	handle: {
		// 		menuLabel: 'Demographics',
		// 		section: 'profile',
		// 		workflowNames: [WORKFLOW_SYSTEM_NAME_CONSTANTS.DEMOGRAPHICS_MAINTENANCE]
		// 	}
		// },
		// {
		// 	path: 'billing',
		// 	handle: {
		// 		section: 'billing',
		// 		menuLabel: 'Billing'
		// 	},
		// 	children: [
		// 		{
		// 			path: 'f2f',
		// 			element: <PatientFaceToFace />,
		// 			handle: {
		// 				menuLabel: 'Face to Face'
		// 			}
		// 		}
		// 	]
		// },
		{
			//catch all route to redirect to overview
			path: '*',
			element: <PatientOverviewRoute />
		}
	]
};
